import React from 'react';

import { ContextGlobal as CG } from 'contexts';
import { useUser } from 'hooks';
import { RHP } from 'providers';

import { useForm } from 'components/form';
import * as Page from 'components/page';

import { EcosystemStep3AddForm } from './EcosystemStep3AddForm';

export function EcosystemStep3Add(props) {
    const user = useUser();
    const { state } = React.useContext(CG);
    const { language } = state;

    const { vars, postCorpEcosystemRelationship } = props.useRankingEcosystem;
    const { ranking } = vars;
    const currDate = new Date();

    // Initialize a new form handler
    const form = useForm({
        year: currDate.getFullYear(),
        otherContact: false,
        ecossystemCompanyName: user?.company?.id ? user?.company?.name : undefined,
    });

    // Custom onChange events
    // const onChange = {
    //     company: () => {
    //         form.emitError({ name: 'company', error: undefined });
    //     },
    // };
    // Check for previous step conclusion
    if (!vars.application.steps || vars.application.steps.step1 !== true) {
        RHP.replace('/ranking/corporate/');
        return null;
    }

    // Handle form submitions
    const onSubmit = values => {
        const payload = {
            year: values.year,
            programName: values.programName,
            description: values.description,
            linkUrl: values.linkUrl,
            ranking,
            entity: 'ecosystem',
            company: {
                name: values.companyName,
                contact: {
                    name: values.companyContactName,
                    email: values.companyContactEmail,
                },
            },
        };

        if (!values.companyName) {
            payload.company.contact.name = values.companyName;
        }

        if (!user?.company?.id) {
            payload.ecosystem = { name: values.ecosystemCompanyName };
        }

        // Add relationship
        return postCorpEcosystemRelationship(payload)
            .then(() => {
                RHP.push('/ranking/latam/ecosystem/step3');
            })
            .catch(() => form.submited());
    };

    const propsForm = { ...props, form, onSubmit, language };
    return (
        <Page.Page name="EcosystemStep3">
            <Page.Title>{props.t('EcosystemStep3.title')}</Page.Title>
            <Page.Descr>{props.t('EcosystemStep3.descr')}</Page.Descr>
            <EcosystemStep3AddForm {...propsForm} />
        </Page.Page>
    );
}
export default EcosystemStep3Add;
